import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { Box, Paper, Grid, Chip } from "@mui/material";
import { VendorUser } from "../helpers/InterfacesServer";
import { VerticalScrollableComponent } from "../layouts/VerticalScrollableComponent";
import { useAppSelector } from '../store/store';

export function ViewVendorUsers() {
    const vendorUsers = useAppSelector(state => state.vendorUsers.value);
    const vendorsDict = useAppSelector(state => state.vendorsDict.value);
    const columns: MRT_ColumnDef<VendorUser>[] = [
        { accessorKey: 'Email', header: 'Email', grow: 1 },
        {
            accessorKey: 'VendorCodes',
            header: 'Vendors',
            grow: 1,
            Cell: ({ cell }) => (
                <Box sx={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                    {cell.getValue<string[]>().map((code, idx) => (
                        <Chip key={idx} label={code+": "+ vendorsDict.get(code)?.VendorName} size="small" color="primary" />
                    ))}
                </Box>
            ),
        },
        {
           accessorFn: (row) => row.IsActive ? 'Active' : "Inactive",
            header: 'Status',
            size: 130,
            Cell: ({ cell }) => (
                <Chip
                    label={cell.getValue<string>()}
                    color={cell.getValue<string>() === 'Active' ? 'success' : 'error'}
                    size="small"
                />
            ),
        },
        { accessorKey: 'InvitationStatus', header: 'InvitationStatus', size: 180 },
        {
            accessorKey: 'UserPrincipalName', header: 'UPN',
            size: 200,
            muiTableBodyCellProps: {
                sx: {
                    whiteSpace: 'normal', // allows wrapping
                    wordBreak: 'break-word', // breaks long words
                    maxWidth: '200px', // optional: limit width for better wrapping
                },
            },
        },
        { accessorKey: 'Id', header: 'ID', size: 150 },
        { accessorKey: 'GuestAccountType', header: 'AccountType', size: 150 },
    ];


    return (
        <Box className='HorizontalOverFlowContainer'>
            <Paper className="Form">
                <br />
                <VerticalScrollableComponent viewPortHeightOffset={162}>
                    <Grid style={{ padding: 10 }} >
                        {vendorUsers && vendorUsers.length > 0 &&
                            <MaterialReactTable<VendorUser> columns={columns} data={vendorUsers} enableColumnResizing enablePagination enableSorting enableColumnFilters
                                mrtTheme={{ baseBackgroundColor: "#ffffff", }} muiTablePaperProps={{ elevation: 0, }}
                            />}
                    </Grid>
                </VerticalScrollableComponent>
                <br />
            </Paper>
        </Box>
    )
}
